import React from "react";

/**
 * PrestiqueResume monogram — inline SVG using Playfair Display text.
 *
 * Variants:
 *   "light" — ink-black P with burnished-gold R (use on ivory/cream surfaces)
 *   "dark"  — warm-ivory P with burnished-gold R (use on matte-black/dark surfaces)
 *
 * Renders crisp at any size without raster artefacts, automatically picks up
 * @import-loaded Playfair Display from the global font face declarations.
 * On dark variant, a thin gold-tinted frame separates the mark from the chrome.
 */
export const BrandMark = ({ variant = "light", size = 40, withFrame = true, className = "" }) => {
  const dark = variant === "dark";
  const pColor = dark ? "#F7F4EE" : "#181A20";
  const rColor = "#B08D57";
  const frameBg = dark ? "#181A20" : "#F7F4EE";
  const frameBorder = dark ? "rgba(176,141,87,0.45)" : "rgba(24,26,32,0.10)";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label="PrestiqueResume"
      data-testid="brand-mark"
    >
      {withFrame && (
        <rect
          x="0.5"
          y="0.5"
          width="47"
          height="47"
          rx="7"
          fill={frameBg}
          stroke={frameBorder}
          strokeWidth="1"
        />
      )}
      <text
        x="24"
        y="34"
        textAnchor="middle"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="600"
        fontSize="26"
        letterSpacing="-1"
      >
        <tspan fill={pColor}>P</tspan>
        <tspan fill={rColor} dx="-2" fontStyle="italic">R</tspan>
      </text>
    </svg>
  );
};

export default BrandMark;
